import React from 'react'

export default function PasswordResetScreen() {
    return (
        <div>
            <h1>Your password has been successfully reset, please login.</h1>
        </div>
    )
}
